import { c as _c } from "react/compiler-runtime";
import { FIELD_FULLTEXT, SearchFormValuesGCSS, useGcssSearch } from './hooks/useGcssSearch';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { useBreadcrumbs } from './hooks/useBreadcrumbs';
import { Filter } from './Filter';
import { Categories } from './Categories';
import { PriceOrder } from './PriceOrder';
import { ProductsCount } from './ProductsCount';
import { Results } from './Results';
import { Form, FormSpy } from 'react-final-form';
import { addPrefixToDataParams } from '@/utils/string';
import { FormApi } from 'final-form';
import type { Category, SubCategory } from './functions/utils';
import { CategoryDescription } from './CategoryDescription';
import { NoResults as NoResultsComponent } from './NoResults';
import { NoResults } from './functions/getNoResultsData';
import { Suspense } from 'react';
type SearchForm = FormApi<SearchFormValuesGCSS, Partial<SearchFormValuesGCSS>>;
interface Props {
  category?: Category | SubCategory;
  formValues: Partial<SearchFormValuesGCSS>;
  sync: (values: Partial<SearchFormValuesGCSS>) => void;
  searchForm: SearchForm;
  noResultsData: NoResults;
}
export function ResultContent(props) {
  const $ = _c(24);
  const {
    category,
    formValues,
    sync,
    searchForm,
    noResultsData
  } = props;
  const t0 = category?.id;
  const t1 = category?.path[0];
  const t2 = category?.path[1];
  let t3;
  if ($[0] !== formValues || $[1] !== t0 || $[2] !== t1 || $[3] !== t2) {
    t3 = {
      formValues,
      categoryId: t0,
      category: t1,
      subcategory: t2
    };
    $[0] = formValues;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    query,
    brandsFilterResult,
    merchantsFilterResult,
    isPending
  } = useGcssSearch(t3);
  const breadcrumbs = useBreadcrumbs(category);
  const hasNoResults = query.data?.pages[0]?.data.length === 0;
  let t4;
  if ($[5] !== breadcrumbs) {
    t4 = <Breadcrumbs className="mt-2" variant="default-with-home" items={breadcrumbs} />;
    $[5] = breadcrumbs;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== brandsFilterResult || $[8] !== category || $[9] !== formValues || $[10] !== hasNoResults || $[11] !== isPending || $[12] !== merchantsFilterResult || $[13] !== noResultsData || $[14] !== query || $[15] !== sync) {
    t5 = t6 => {
      const {
        handleSubmit
      } = t6;
      return <form onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "gcssResultContent",
        testId: "gcssResultContent",
        prefix: "form"
      })} className="grid md:grid-cols-5"><FormSpy subscription={{
          values: true
        }} onChange={t7 => {
          const {
            values
          } = t7;
          return sync(values);
        }} /><Filter brandsFilterResult={brandsFilterResult} merchantsFilterResult={merchantsFilterResult} initialValues={formValues} isPending={isPending} /><div className="py-8 md:col-span-4 md:pl-8">{hasNoResults ? <NoResultsComponent data={noResultsData} fulltext={formValues[FIELD_FULLTEXT]} category={category} /> : <>{category && <><h1 className="mb-8 font-bold lg:text-4xl">{category.name}</h1><Suspense>{category.description && <CategoryDescription text={category.description} />}</Suspense><Categories categorySlug={category.slug} subcategories={category.subcategories} variant={category && "minimal"} /></>}<hr className="mb-5 bg-gray-100" /><div className="mb-6 grid grid-cols-2"><ProductsCount /><PriceOrder initialValues={formValues} /></div><Results query={query} category={category} /></>}</div></form>;
    };
    $[7] = brandsFilterResult;
    $[8] = category;
    $[9] = formValues;
    $[10] = hasNoResults;
    $[11] = isPending;
    $[12] = merchantsFilterResult;
    $[13] = noResultsData;
    $[14] = query;
    $[15] = sync;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== formValues || $[18] !== searchForm || $[19] !== t5) {
    t6 = <Form onSubmit={searchForm.submit} form={searchForm} initialValues={formValues}>{t5}</Form>;
    $[17] = formValues;
    $[18] = searchForm;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t6) {
    t7 = <div className="relative mx-auto max-w-[1728px] overflow-hidden bg-white px-4 pt-40 lg:pt-32">{t4}{t6}</div>;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}